export default "__VITE_ASSET__KpxvtyX5__"